import { render, staticRenderFns } from "./OrderTotalCard.vue?vue&type=template&id=45d276cc&"
import script from "./OrderTotalCard.vue?vue&type=script&lang=js&"
export * from "./OrderTotalCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports